export { WidgetWallets, WidgetContext } from './Wallets';
